<template>
    <div>
        <el-dialog v-if="dialogFormVisible" v-el-drag-dialog :visible.sync="dialogFormVisible" :close-on-click-modal="false" :width="'1000px'" :title="'批量导入开票信息'">
            <el-form :model="vo">
                <div class="el-table el-table--fit el-table--border inner-table">
                    <div class="el-table__body-wrapper">
                        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                            <tbody>
                                <tr>
                                    <td class="el-table__cell tdlbl tdw17">
                                        <span class="required">*</span>
                                        上传文件
                                    </td>
                                    <td class="el-table__cell tdcont tdw83">
                                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="上传文件" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-upload ref="upload" :on-change="handleUploadChange" action="" :file-list="fileList" :show-file-list="false" :auto-upload="false" :with-credentials="true" :accept="'.xls,.xlsx'">
                                                    <el-input v-model="salaryAttachName" name="salaryAttachName" placeholder="请选择文件">
                                                        <el-button slot="append" icon="el-icon-upload2" />
                                                    </el-input>
                                                </el-upload>
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                                <!-- <tr>
                  <td class="el-table__cell tdlbl tdw17"><span class="required">*</span>年度</td>
                  <td class="el-table__cell tdlbl tdw33"><el-input v-model="yearNo" name="yearNo" placeholder="请输入年度">

                  </el-input></td>
                  <td class="el-table__cell tdlbl tdw17"><span class="required">*</span>批次</td>
                  <td class="el-table__cell tdlbl tdw33"><el-input v-model="barchName" name="barchName" placeholder="请输入批次">

                  </el-input></td>
                </tr> -->
                                <tr>
                                    <td class="el-table__cell tdlbl tdw17">注意事项</td>
                                    <td class="el-table__cell tdcont tdw83">
                                        <div style="line-height: 25px">
                                            <span><strong>上传文件内容格式说明：</strong></span>
                                            <br />
                                            <span>1.导入文件应为Office Excel文件;</span>
                                            <br />
                                            <span>2.导入文件暂不支持Office 2007及以后版本的Excel文件，如您使用的是Office 2007及以后版本，请把Excel文件转换为2003或之前的版本格式，具体转换方式为：打开的Excel文件中，选择“另存为”->“Excel 97-2003工作簿”；</span>
                                            <br />
                                            <span>3.进行导入操作时，请确保您导入的文件并未处于使用状态。</span>
                                            <br />
                                            <span>
                                                <strong>上传文件内容示例：</strong>
                                            </span>
                                            <br />
                                            <span>
                                                <a title="点击下载" @click="fileDownload('/templates/kpmximport.xlsx')"><span style="color: red; width: 100%">点击下载Excel导入示例</span></a>
                                            </span>
                                        </div>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button v-for="(btn, key) in busiformBtns" :key="key" :disabled="doing" :plain="btn.btnType === null || btn.btnType === ''" :icon="'el-icon-' + btn.btnIcon" :type="btn.btnType !== null ? btn.btnType : ''" @click="btn.btnClick">{{ btn.btnName }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            dialogFormVisible: false,
            salaryAttachName: '',
            fileList: [],
            doing: false,
            yearNo: '', // 年度
            barchName: '', // 批次
            voId: '', // 导入的id
            busiformBtns: [
                {
                    id: 'btn_close',
                    btnName: '关 闭',
                    btnIcon: 'close',
                    btnClick: this.closeDialog,
                    btnPermission: '',
                    btnType: ''
                },
                {
                    id: 'btn_save',
                    btnName: '导 入',
                    btnIcon: 'check',
                    btnClick: this.submitSalary,
                    btnPermission: 'saveObject',
                    btnType: 'primary'
                }
            ],
            callback: null,
            finType: false
        }
    },
    computed: {},
    watch: {},
    created() {
        this.$bus.on('openImportForm', this.openImportForm)
    },
    beforeDestroy() {
        this.$bus.off('openImportForm', this.openImportForm)
    },
    mounted() {},
    methods: {
        down(url) {
            this.fileDownload(url)
        },
        openImportForm(id, callback) {
            this.voId = id
            this.callback = callback
            this.dialogFormVisible = true
        },
        handleUploadChange(filed, fileList) {
            if (filed.name.indexOf('.xls') === -1 && filed.name.indexOf('.xlsx')) {
                this.$alert('上传文件格式错误', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                })
                this.fileList = []
                this.salaryAttachName = ''
                return
            }
            this.fileList = [filed]
            this.salaryAttachName = filed.name
        },
        submitSalary() {
            this.formValidate(() => {
                this.doing = true
                const file = new FormData()
                file.append('file', this.fileList[0].raw)
                this.$http({
                    url: '/cwgl/invoiceApplyItem/importData?formId=' + this.voId,
                    method: 'POST',
                    data: file
                }).then((res) => {
                    if (res.code === 'success') {
                        if (res.body.failureCount > 0) {
                            this.$message({
                                message: res.body.failureMsg[0],
                                type: 'warning'
                            })
                        } else if (res.body.successCount > 0) {
                            this.$message({
                                message: res.message,
                                type: 'success'
                            })
                        }

                        this.closeDialog()
                    } else {
                        this.$message.error(res.message)
                    }
                    this.$nextTick(() => {
                        this.doing = false
                        this.finType = true
                        this.callback(this.finType)
                    })
                })
            })
        },
        closeDialog() {
            this.dialogFormVisible = false
            this.salaryAttachName = ''
            this.fileList = []
        }
    }
}
</script>

<style scoped lang="scss">
.el-tooltip {
    /deep/ .el-upload.el-upload--text {
        width: 100%;
    }
}
</style>
